import {Plans} from '../../../../types/src'

export function isClientTrial(type: string) {
  return type === Plans.TRIAL || type === Plans.ON_HOLD;
}
